import { initScrollUp } from './features/scrollUp.js';
import { initCollapses } from './features/collapses.js';
import { initTabs } from './features/tabs.js';
import { initTabsTagsArrows } from './features/tabsTagsArrows.js';
import { initCarousels } from './features/carousels.js';
import { initSubSection } from './features/subSection.js';
import { initTestimonials } from './features/testimonials.js';
import { initChainedFlow } from './features/chainedFlow.js';
import { initCustomSelect } from './features/customSelect.js';
import { initTooltips } from './features/tooltips.js';
import { initAnchors } from './features/anchors.js';
import { initTable } from './features/table.js';
import { initModuleCards } from './features/moduleCards.js';
import { initMatomoTracking } from './integrations/matomo.js';

const MODULE_INITS = [
    initScrollUp,
    initCollapses,
    initTabs,
    initTabsTagsArrows,
    initCarousels,
    initSubSection,
    initTestimonials,
    initChainedFlow,
    initCustomSelect,
    initTooltips,
    initAnchors,
    initTable,
    initModuleCards,
    initMatomoTracking,
];

export function initModules() {
    MODULE_INITS.forEach((fn) => {
        try {
            fn();
        } catch (error) {
            console.error(`[silae] init module failed: ${fn.name || 'anonymous'}`, error);
        }
    });
}
